import { useSuspenseQuery } from '@tanstack/react-query';

import AgreeInfoService from 'legacy/api/AgreeInfoService';

export const useGetCcrcDetailData = ({ ccrcGuidId, hspCd, hspId }) => {
  const {
    data: { data },
  } = useSuspenseQuery({
    queryKey: ['detailModal'],
    queryFn: () => AgreeInfoService.excuteAgreeInfo({ ccrcGuidId, hspCd, hspId }),
    gcTime: 0,
  });
  return data;
};
